import React from 'react';
import {
  Wrapper,
  HtmlContent,
} from '../common';
import './PostFeaturedList.scss';

const PostFeaturedList = (props) => {
  const {
    data,
  } = props;
  const {
    primary,
    items: listItems,
  } = data;
  const {
    title,
  } = primary;
  return (
    <section className="post-featured-list">
      <Wrapper isBound>
        <h2 className="list-title">{title.text}</h2>
        <ul className="feature-list">
          { listItems.map((item, index) => (
            <li
              key={index} // eslint-disable-line
              className="featured-list-item"
            >
              <svg viewBox="0 0 107 102" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M2.522 36.47l11.152-18.803C18.758 11.261 25.537 6.8 34.012 4.283 46.722.51 54.96-.996 69.97 4.283c4.126 1.452 8.016 2.512 11.669 3.18l8.173 3.409c9.331 8.379 14.563 15.793 15.696 22.243 1.698 9.674.599 35.923-14.314 50.235-14.913 14.312-25.795 14.584-40.337 17.99-14.543 3.406-31.959-10.429-40.616-22.006C2.305 68.72.401 61.988.14 56.664a28.799 28.799 0 01-.034-1.417c0-3.7.805-9.96 2.416-18.778z"
                  fillRule="evenodd"
                />
              </svg>
              <HtmlContent content={item.listItem.html} />
            </li>
          ))}
        </ul>
      </Wrapper>
    </section>
  );
};

export default PostFeaturedList;
